import React, { Fragment, useState, useEffect, useContext, useRef } from 'react'
import ReactGA from 'react-ga'

import { get, set } from 'idb-keyval'
// we shim an implementation of "next/dynamic" in DS9 in webpack
// we HAVE to use magic comments https://loadable-components.com/docs/babel-plugin/#magic-comments
import dynamic from 'next/dynamic'
import useWindow from 'Hooks/useWindow'
//import LoyaltyNonBetaModalContent from './LoyaltyNonBetaModalContent'
import { NavigationContext } from 'Contexts/Navigation/NavigationContext'

import { UserContext } from 'Contexts/UserContext/UserContext'
import { NotificationContext } from '../../Contexts/NotificationContext/NotificationContext'
// we shim an implementation of "next/dynamic" in DS9 in webpack
// we HAVE to use magic comments https://loadable-components.com/docs/babel-plugin/#magic-comments
const LoyaltyNonBetaModalContent = dynamic(/* #__LOADABLE__ */() => import('./LoyaltyNonBetaModalContent'))

const LoyaltyNonBetaModal = () => {
    const { state: navigationState, dispatch: navigationDispatch } = useContext(NavigationContext)
    const [isOpen, setIsOpen] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const modal = useRef(null)
    const { DismissAllNotifications } = useContext(NotificationContext)

    useEffect(() => {
        const { nonBeta } = navigationState;
        setIsOpen(nonBeta?.isLoyaltyNonBetaModalOpen ?? false)
        if (nonBeta?.isLoyaltyNonBetaModalOpen) {
            DismissAllNotifications()
            ReactGA.event({
                category: 'Non-Beta Acknowledgement',
                action: 'Modal',
                label: 'Displayed Modal',
                nonInteraction: true,
            })
        }
    }, [navigationState])

    const handleNavigationChange = (value) => navigationDispatch({
        type: 'setNonBetaState',
        payload: {
            nonBetaState: {
                isLoyaltyNonBetaModalOpen: value
            }
        }
    })

    useWindow((window) => {
        setShowModal(window.location.href.includes('/loyalty'))
    })

    const { context: customerState } = useContext(UserContext)
    useEffect(() => {
        const isHydrated = customerState?.hydrated
        const isLoyaltyBetaUser = customerState?.isLoyaltyBetaUser
        const isLoggedIn = customerState?.isRegistered
        if (showModal && isHydrated && !isLoyaltyBetaUser && isLoggedIn) {
            setTimeout(function () {
                handleNavigationChange(true)
            }, 0)
        }
    }, [customerState])

    return (
        <Fragment>
            {isOpen ?
                <LoyaltyNonBetaModalContent ref={modal} />
                : false}
        </Fragment>
    )
}
export default LoyaltyNonBetaModal
